import { Type } from '@angular/core';

import { TableCellData } from '@site-mate/dashpivot-shared-library';

export class TemplateTableCell {
  companyId: string;
  isOrganisationTemplate: boolean;
  constructor(public component: Type<any>, public cellData: TableCellData) {}
}
